export enum ButtonVariant {
  round = "round",
  text = "text"
}
